import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import React from 'react';
import { sortDoughnutSeriesByValue } from '@/modules/finances/lib/doughnut-chart-utils';
import type { DoughnutSeries } from '@/modules/finances/types';
import { ItemLegendDoughnut } from './card-legend-item';
interface CardLegendProps {
  isDeepLevel?: boolean;
  changeAlignment: boolean;
  doughnutSeriesData: DoughnutSeries[];
  toggleSeriesVisibility: (seriesName: string) => void;
  onLegendItemLeave: (legendName: string) => void;
  onLegendItemHover: (legendName: string) => void;
}
function CardLegend(t0) {
  const $ = _c(21);
  const {
    changeAlignment,
    isDeepLevel: t1,
    doughnutSeriesData,
    onLegendItemHover,
    onLegendItemLeave,
    toggleSeriesVisibility
  } = t0;
  const isDeepLevel = t1 === undefined ? true : t1;
  let t2;
  let t3;
  if ($[0] !== changeAlignment || $[1] !== doughnutSeriesData || $[2] !== isDeepLevel || $[3] !== onLegendItemHover || $[4] !== onLegendItemLeave || $[5] !== toggleSeriesVisibility) {
    const sortedDoughnutSeries = sortDoughnutSeriesByValue(doughnutSeriesData);
    const t4 = isDeepLevel ? "gap-1" : "gap-2";
    const t5 = isDeepLevel ? "xl:gap-y-2.5" : "xl:gap-y-2";
    const t6 = changeAlignment || isDeepLevel ? "justify-start" : "justify-center";
    if ($[8] !== t4 || $[9] !== t5 || $[10] !== t6) {
      t2 = cn("flex flex-col flex-wrap", "max-h-38.75 w-auto max-w-full", t4, t5, t6, "xl:gap-x-6");
      $[8] = t4;
      $[9] = t5;
      $[10] = t6;
      $[11] = t2;
    } else {
      t2 = $[11];
    }
    let t7;
    if ($[12] !== changeAlignment || $[13] !== isDeepLevel || $[14] !== onLegendItemHover || $[15] !== onLegendItemLeave || $[16] !== toggleSeriesVisibility) {
      t7 = data => <ItemLegendDoughnut key={data.name} changeAlignment={changeAlignment} doughnutData={data} onLegendItemHover={onLegendItemHover} onLegendItemLeave={onLegendItemLeave} toggleSeriesVisibility={toggleSeriesVisibility} isDeepLevel={isDeepLevel} />;
      $[12] = changeAlignment;
      $[13] = isDeepLevel;
      $[14] = onLegendItemHover;
      $[15] = onLegendItemLeave;
      $[16] = toggleSeriesVisibility;
      $[17] = t7;
    } else {
      t7 = $[17];
    }
    t3 = sortedDoughnutSeries.map(t7);
    $[0] = changeAlignment;
    $[1] = doughnutSeriesData;
    $[2] = isDeepLevel;
    $[3] = onLegendItemHover;
    $[4] = onLegendItemLeave;
    $[5] = toggleSeriesVisibility;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  let t4;
  if ($[18] !== t2 || $[19] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  return t4;
}
export { CardLegend };